import { EstadoLote, PasoDevolucion } from "../../interfaces";

export const resolveReturnBundleState = (
    pasos: PasoDevolucion[]
): { estado: EstadoLote; fechaSalidaOffsetDays: number } => {
    if (pasos.includes("Alertas")) {
        return { estado: "Incompleto", fechaSalidaOffsetDays: 1 };
    }
    if (pasos.includes("Retrasos")) {
        return { estado: "En Armado", fechaSalidaOffsetDays: 8 };
    }
    return { estado: "En Armado", fechaSalidaOffsetDays: 2 };
};
